import { useTheme } from '@mui/material';
import { Section, TestimonialsSlider } from '@rumblefish/ui/Rumblefish23Theme';
import React from 'react';
import {
  StyledStack,
  StyledTextStack,
  StyledHeaderWrapper,
  StyledHeader,
  StyledHeading,
  StyledAccentBar,
  TestimonialsSection,
} from './styles';
import type { TestimonialsProps } from './Testimonials.types';

export const Testimonials = ({
  testimonialsData,
  ...props
}: TestimonialsProps): React.ReactElement => {
  const theme = useTheme();
  const isMobile = theme.utils.isMobile();

  return (
    <TestimonialsSection width="full" borderBottomOn={!isMobile}>
      <StyledStack {...props}>
        <Section width="normal" mobilePadding={false}>
          <StyledTextStack>
            <StyledHeaderWrapper>
              <StyledHeader>
                <StyledHeading variant="h2">
                  Don&apos;t take our word for it
                </StyledHeading>
                <StyledAccentBar />
              </StyledHeader>
            </StyledHeaderWrapper>
          </StyledTextStack>
        </Section>
        <TestimonialsSlider testimonialsData={testimonialsData} />
      </StyledStack>
    </TestimonialsSection>
  );
};
